export default URL = "https://hacker-news.firebaseio.com/v0"

export function fetchStories(type) {
	return fetch(`${URL}/${type}stories.json`)
		.then(res => res.json())
}

export function fetchItem(itemId) {
	return fetch(`${URL}/item/${itemId}.json`)
		.then(res => res.json())
}
